import React, { useRef, useState, useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import updateParams from "utils/updateParams.js";



export default function SaveChanges(props) {
  return (
    <Row>
      <Col className="text-center text-md-right px-md-3 px-5">
          <Button
            style={{
              paddingTop: "9px",
              paddingBot: "9px",
              paddingRight: "35px",
              paddingLeft: "35px",
            }}
            className="mt-0 mb-4 mt-md-4"
            as="input"
            type="submit"
            value="Save Changes"
            variant="success"
            id="org-save-btn"
          />
      </Col>
    </Row>
  );
}
